export default "__VITE_ASSET__BuL8EypJ__"